import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../../shared';
import { RouterModule } from '@angular/router';
import { CreateProgramDialogComponent, CreateProgramPopupComponent } from './create-program-dialog.component';
import { ProgramService } from '../../shared/program/service/program.service';
import { CREATE_PROGRAM_ROUTES } from './create-program.route';
import { HelpLinkComponent } from '../../shared/help-link/help-link.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(CREATE_PROGRAM_ROUTES),
        HelpLinkComponent
    ],
    declarations: [
        CreateProgramDialogComponent,
        CreateProgramPopupComponent,
    ],
    providers: [
        ProgramService
    ]
})
export class CreateProgramModule {

}
